import { IConfirmableInjectedAction } from '../../../../interfaces';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { get } from 'lodash';

export class InjectedTriggerMigrationRollback implements IConfirmableInjectedAction {
  performActionAfterConfirm = (bindObj, action) => {
    const rollbackId = get(action, 'rowData.migrationVariables.sourceTransactionUUID');

    if (!rollbackId) {
      bindObj.worklist.notificationMessageService.error('Please choose valid rollback id');
      return;
    }
    this.refreshWorklist(bindObj, action, 'Rollback in-progress');
    bindObj.worklist.dataMigrationService.triggerRollbackImport(rollbackId)
      .subscribe(
        (data) => {
          const qtyVersionsRemoved = get(data, 'totalQtyVersionRemoved', 0);

          if (get(data, 'status') === 'Rollback in-progress') {
            bindObj.worklist.notificationMessageService.info(`Rollback trigger for rollbackId:   ${rollbackId}  in-progress`);
          } else if (get(data, 'status') === 'Rollback completed') {
            this.refreshWorklist(bindObj, action, get(data, 'status', 'Rollback completed'));
            bindObj.worklist.notificationMessageService.success(`Rollback trigger for rollbackId:  ${rollbackId}  successfully completed. Total ${qtyVersionsRemoved} records removed from database.`);
          } else {
            this.refreshWorklist(bindObj, action, get(data, 'status', 'Rollback failed'));
            bindObj.worklist.notificationMessageService.error(`Rollback trigger for rollbackId:   ${rollbackId}  Failed`);
          }
        },
        catchError((err) => {
          console.error('Rollback failed : Error : ', err.message);
          this.refreshWorklist(bindObj, action, 'Rollback failed');
          bindObj.worklist.notificationMessageService.error(`Rollback trigger Exception for rollbackId:   ${rollbackId}`);

          return of(err);
        })
    );
  }

  refreshWorklist = (bindObj, action, status) => {
    bindObj.worklist.refreshWorklist(
      bindObj.worklist,
      { status: status },
      null,
      action.rowData.meta,
      action.rowData.id
    );
  }
}
